import React from 'react';
import LoginForm from './loginForm';
import {  useDispatch, useSelector } from 'react-redux';
import { loginApi, selectLoginData } from './loginSlice';


interface LoginData {
  email: string
  password: string
  isLoading: boolean
}
interface LoginCredentials {
  email: string
  password: string
}

const LoginFormContainer = () => {
  const dispatch = useDispatch();
  const loginData = useSelector(selectLoginData);
  
  const onFinish = (values: LoginCredentials) => {
    dispatch(loginApi(values));
  };
    return (
      <div className="App flex justify-center mt-8" >
        <div className="w-full max-w-md flex justify-center items-center mb-16" >
          <LoginForm onFinish={onFinish} loginData={loginData} />
        </div>
      </div>
    );
  };
  
  export default LoginFormContainer;